import { IApiBaseErrorResponse } from '@app/api/interfaces/api-base-error-response.interface';
import { MonthsDateRangeType } from '@app/core/date-range/enums/months-date-range-type.enum';
import { IDateRange } from '@app/core/date-range/interfaces/date-range.interface';
import { ICombinedSpreadChartData } from '@app/main/leak-detection/floating-popups/floating-popup-logger-noise/tabs/fp-logger-noise-spread/interfaces/combined-spread-chart-data';
import { ILdLogger } from '@app/main/leak-detection/interfaces/ld-logger';

export enum FpLoggerNoiseSpreadActionType {
  GetData = 'GetData',
  GetDataSuccesses = 'GetDataSuccesses',
  GetDataError = 'GetDataError',
  ToggleChartFullscreen = 'ToggleChartFullscreen',
  UpdatePeriod = 'UpdatePeriod',
}

export interface FpLoggerNoiseSpreadActionGetData {
  type: FpLoggerNoiseSpreadActionType.GetData;
  date: string | null;
  popupMainData: ILdLogger | null;
}

export interface FpLoggerNoiseSpreadActionGetDataSuccesses {
  type: FpLoggerNoiseSpreadActionType.GetDataSuccesses;
  date: string | null;
  cacheDateRange?: IDateRange | null;
  cacheData?: ICombinedSpreadChartData[] | null;
  popupMainData: ILdLogger | null;
  data: ICombinedSpreadChartData[] | null;
}

export interface FpLoggerNoiseSpreadActionGetDataError {
  type: FpLoggerNoiseSpreadActionType.GetDataError;
  date: string | null;
  popupMainData: ILdLogger | null;
  error: IApiBaseErrorResponse;
}

export interface FpLoggerNoiseSpreadActionToggleChartFullscreen {
  type: FpLoggerNoiseSpreadActionType.ToggleChartFullscreen;
  synchronizeWithPopupId?: string;
}

export interface FpLoggerNoiseSpreadActionUpdatePeriod {
  type: FpLoggerNoiseSpreadActionType.UpdatePeriod;
  period: MonthsDateRangeType;
}

export type FpLoggerNoiseSpreadActions =
  | FpLoggerNoiseSpreadActionGetData
  | FpLoggerNoiseSpreadActionGetDataSuccesses
  | FpLoggerNoiseSpreadActionGetDataError
  | FpLoggerNoiseSpreadActionToggleChartFullscreen
  | FpLoggerNoiseSpreadActionUpdatePeriod;
